const items = [
  "THE FIRST WOLF",
  "APRIL 2027",
  "STREET APPAREL & COUTURE",
  "SANZONE",
  "WEAR THE ART",
  "LEAD THE PACK",
  "INSTINCT. REFINED.",
];

const Strip = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className={`whitespace-nowrap px-8 text-xs uppercase tracking-[0.4em] ${i % 2 === 0 ? "font-caps text-[#F4EEE3]" : "font-code text-[#9A7B3F]"}`}>
          {item}
        </span>
        <span className="h-1 w-1 rotate-45 bg-[#9A7B3F]/70" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-[#9A7B3F]/30 bg-[#221812] py-5"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max">
        <Strip />
        <Strip hidden />
      </div>
    </div>
  );
}
